import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { CookieCategory } from "./cookie-consent.types";

export type CookiesConsent = {
  [key in CookieCategory]: boolean | null;
};

type ConsentState = {
  cookiesConsent: CookiesConsent;
  updateCookiesConsent: (cookies: Partial<CookiesConsent>) => void;
};

const defaultCookiesState: CookiesConsent = {
  desempenho: null,
  publicidade: null,
  funcionalidade: null,
  necessario: true,
};

export const useCookieConsentStore = create<ConsentState>()(
  persist(
    (set) => ({
      cookiesConsent: defaultCookiesState,
      updateCookiesConsent: (cookies: Partial<CookiesConsent>) => {
        set({ cookiesConsent: { ...defaultCookiesState, ...cookies } });
      },
    }),
    {
      name: "user-consent",
      partialize: (state) => ({ cookiesConsent: state.cookiesConsent }),
      storage: createJSONStorage(() => localStorage),
    }
  )
);
